// extracted by mini-css-extract-plugin
module.exports = {"btn":"w_r p_rx p_q8 h_fq h_fF h_ft h_hg","full":"w_sR h_dq h_dB"};